module.exports = __webpack_public_path__ + "static/media/photo44.7a4f0471.jpg";